

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { DepartmentsSetup } from "../../components/DepartmentsSetup";


export const DepartmentsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Departments Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/departments/list" },
        { text: "Departments", navigateTo: "/company/departments/setup" }
      ]}
      mainContents={<DepartmentsSetup />}
    />
  );
};
